// extracted by mini-css-extract-plugin
export default {"birthdayBox":"style_birthdayBox__bH4Zt","boxHeader":"style_boxHeader__Gwibg","birthdayList":"style_birthdayList__nVbrm","name":"style_name__N4Glm","today":"style_today__Qf27s"};